module.exports = __webpack_public_path__ + "36da60581b514baf943cf6d4b8819df0.svg";